import React, { useState } from 'react';
import { DetailExpandableItemWrapper, ItemHeader, ItemTitle, ExpandIcon, ItemContent } from './detail-expandable-item.style';
import DetailExpandSvg from '../assets/detail-expand.svg';
import DetailCollapseSvg from '../assets/detail-collapse.svg';

export interface DetailExpandableItemProps {
    id: string;
    title: string;
    description: string;
}

const DetailExpandableItem: React.FC<DetailExpandableItemProps> = ({ id: _id, title, description }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <DetailExpandableItemWrapper>
            <ItemHeader onClick={toggleExpanded}>
                <ItemTitle>{title}</ItemTitle>
                <ExpandIcon isExpanded={isExpanded}>
                    {isExpanded ? (
                        <DetailCollapseSvg aria-hidden="true" />
                    ) : (
                        <DetailExpandSvg aria-hidden="true" />
                    )}
                </ExpandIcon>
            </ItemHeader>
            {isExpanded && (
                <ItemContent>
                    {description}
                </ItemContent>
            )}
        </DetailExpandableItemWrapper>
    );
};

export default DetailExpandableItem;
